import cx from "@hsl/core/utils/cx";

import { type SubscribableAsset } from "../../../../../openapi";

export type Frequency = SubscribableAsset["frequency"];

type Props = {
    frequencies: Array<{ key: Frequency; label: React.ReactNode }>;
    value: Frequency;
    onChange?(f: Frequency): void;
    className?: string;
};

const FrequencySelector = ({
    frequencies,
    value = "DAILY",
    onChange,
    className,
}: Props) => {
    const isSelected = (f: Frequency) => f === value;
    return (
        <div
            className={cx(
                "grid max-w-[75%] grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3 lg:max-w-xl lg:grid-cols-4",
                className,
            )}
        >
            {frequencies.map((f, i) => (
                <div
                    key={`${i}-${f.key}`}
                    className={cx(
                        "rounded-sm bg-gray-200 text-sm font-medium max-sm:px-3 max-sm:py-2 sm:p-3 sm:text-center",
                        isSelected(f.key) && "bg-core-green text-white",
                        f.key === "DAILY" && "sm:px-5",
                    )}
                    onClick={() => onChange && onChange(f.key)}
                >
                    {f.label}
                </div>
            ))}
        </div>
    );
};

export default FrequencySelector;
